import ProductsPage from "./ProductsPage";

function HomePage() {
    return (
        <main>
            <h1 className="home-page-header">Browse Our Products!</h1>
            <ProductsPage />
        </main>
    )
}

export default HomePage;